import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HashRouter, BrowserRouter } from 'react-router-dom';
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
    <div className="footer">
      <p>© 2023 Power by AllenChen. All rights reserved.</p>
    </div>
  </React.StrictMode>
);

reportWebVitals();
